module.exports = __webpack_public_path__ + "static/media/404.7eee5be1.png";